<template>
  <!--  
        Usage: 
        
        this.$store.commit('setFeedbackDialog', { 
          title:'', 
          msg: '', 
          type:'', 
          action: '',
          id_bet: '' (if action printBet )
        })
      
      // title = string
      // msg = string
      // type = string ('success', 'warning', 'error', 'info')
      // action = string ('login', 'refresh', printer, 'printBet', 'confirm') 
  -->

  <v-dialog v-model="dialog" max-width="600">
    <v-card light>
      <!-- Title -->
      <v-toolbar max-height="64" elevation="0" class="transparent">
        <v-toolbar-title>{{ feedback.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Msg -->
      <v-card-text class="px-4 pb-0">
        <v-alert :type="feedback.type" prominent>{{ feedback.msg }}</v-alert>
      </v-card-text>

      <!-- <v-divider></v-divider> -->
      <!-- Buttons Actions -->
      <v-card-actions class="pa-4">
        <div class="flex-grow-1"></div>
        <!-- <v-btn text @click="dialog = !dialog">FECHAR</v-btn> -->

        <!--  
          ##
          ## ACTIONS (Personalizados)
          ##
        -->

        <!-- 
          Action Redirect login page (action: 'login') 
        -->
        <v-btn
          depressed
          class="info"
          v-if="feedback.action === 'login'"
          @click="[$router.push({ name: 'Home' }), (dialog = !dialog)]"
        >
          &nbsp;LOGIN&nbsp;
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>

        <!-- 
          Action Refresh page (action: 'refresh') 
        -->
        <v-btn
          depressed
          class="info"
          v-if="feedback.action === 'refresh'"
          @click="[$router.go(''), (dialog = !dialog)]"
        >
          &nbsp;{{ $t("update") }}&nbsp;
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <!-- 
          Action Imprimir bet (action: 'printBet') 
        -->
        <v-btn
          depressed
          class="white black--text d-print-none"
          :disabled="disabled"
          v-if="feedback.action === 'printBet'"
          @click="printBet(), (disabled = true)"
        >
          {{ $t("print") }} &nbsp;
          <v-icon class="ml-2">mdi-printer</v-icon>
        </v-btn>

        <!-- 
          Action Imprimir bet (action: 'printBet') 
        -->
        <v-btn
          depressed
          class="white black--text d-print-none"
          v-if="feedback.action === 'printer'"
          @click="dialog = !dialog"
        >
          {{ $t("print") }} &nbsp;
          <v-icon>mdi-printer</v-icon>
        </v-btn>

        <!-- 
          Action Confirmação (action: 'confirm') 
        -->
        <v-btn
          depressed
          class="white black--text d-print-none"
          v-if="feedback.action === 'confirm'"
          @click="dialog = !dialog"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          depressed
          class="info d-print-none"
          v-if="feedback.action === 'confirm'"
          @click="actionConfirm()"
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "feedbackDialog",
  data: () => ({
    dialog: false,
    disabled: false,
  }),
  computed: {
    feedback() {
      return this.$store.state.feedbackDialog;
    },
  },
  watch: {
    feedback() {
      this.dialog = true;
      this.disabled = false;
    },
  },
  methods: {
    // Action "Print Bet"
    printBet: async function() {
      if (!this.feedback.id_bet) {
        console.warn(this.$t("submitBetId"));
        return;
      }
      // No ato de imprimir é obrigatório setar 1 no printed
      // do endpoint 'agent/bets/getBetAgent'
      await this.$bet.getBetAgent(this.feedback.id_bet, 1);
      this.$printBet();
    },
    // Action "Confirm"
    actionConfirm() {
      this.$store.commit("setActionConfirm", true);
      this.dialog = false;
    },
  },
};
</script>
